// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2M85B","info":"PatientInfo_info__azeoh"};